import React, { useState, useRef, useEffect } from "react";
import BackIcon from "../../comman/action/BackIcon";
import ImageUploader from "../../comman/imageUploader/ImageUploader";
import { Input, ReactSelector, Select, TextArea } from "../../components/Form";
import toast from "react-hot-toast";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { resourceDetailsApi, updateResourceApi } from "../../services/resource";
import { useNavigate, useParams } from "react-router-dom";
import { catchMessage, elseMessage } from "../../comman/Message";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { cityApi, countryApi, stateApi } from "../../services/masterApi";
import { fathCategoryApi } from "../../services/category";

const EditResource = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [imageApi, setApiImage] = useState("");

  const fileInputRef = useRef(null);
  const [input, setInput] = useState({
    name: "",
    externalLink: "",
    category: "",
    description: "",
    locationType: "",
  });
  const [error, setError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Create a resource");
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  //------------handle-Country-onChange--------------
  const handleCountry = (event) => {
    setSelectedCountry(event);
    setSelectedState("");
    setSelectedCity("");
    if (!event?.value) {
      setState([]);
      setSelectedState("");
      setCity([]);
      setSelectedCity("");
    }
  };
  //------------handle-state-onChange--------------
  const handleState = (event) => {
    setSelectedState(event);
    setSelectedCity("");
    if (!event?.value) {
      setCity([]);
      setSelectedCity("");
    }
  };

  const validation = () => {
    let errorMessage = {};
    let status = true;

    if (
      input?.name &&
      input?.externalLink &&
      input?.description &&
      input?.category
    ) {
      if (!image?.name && !image) {
        toast.error("Please choose cover image", { id: "id" });
        status = false;
      }
    }
    if (
      input?.name &&
      input?.externalLink &&
      input?.description &&
      input?.category
    ) {
      if (!input?.locationType) {
        toast.error("Please select location type", { id: "id" });
        status = false;
      }
    }
    if (!input?.name) {
      errorMessage["name"] = "please enter resource name";
      status = false;
    }
    if (!input?.externalLink) {
      errorMessage["externalLink"] = "Please enter an external link";
      status = false;
    } else {
      const urlPattern = /^https:\/\/.*/;
      // Check if the URL is correctly formatted
      if (!urlPattern.test(input.externalLink)) {
        errorMessage["externalLink"] = "URL must start with https://";
        status = false;
      }
    }

    if (!input?.description) {
      errorMessage["description"] = "please enter description";
      status = false;
    }
    if (!input?.category) {
      errorMessage["category"] = "please select category";
      status = false;
    }
    if (input?.locationType === "country") {
      if (!selectedCountry?.value) {
        errorMessage["country"] = "Please select country";
        status = false;
      }
      // if (!selectedState?.value) {
      //   errorMessage["state"] = "Please select state";
      //   status = false;
      // }
      // if (!selectedCity?.value) {
      //   errorMessage["city"] = "Please select city";
      //   status = false;
      // }
    }
    setError(errorMessage);
    return status;
  };

  //----------onChange----------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (name === "name") {
    //   const cleanedName = value
    //     .replace(/^[ ]+/g, "")
    //     .replace(/[^A-Za-z ]/gi, "")
    //     .replace(/\s+/g, " ");
    //   setInput({ ...input, [name]: cleanedName });
    // } else 
    if (name === "externalLink") {
      const cleanedName = value.replace(/^[ ]+/g, "").replace(/\s+/g, "");
      setInput({ ...input, [name]: cleanedName });
    } else if (name === "description") {
      const cleanedName = value.replace(/^[ ]+/g, "");
      setInput({ ...input, [name]: cleanedName });
    } else {
      setInput({ ...input, [name]: value });
    }
  };
  //------------------category-listing-Api----------------------------------
  useEffect(() => {
    const fathCategory = async () => {
      setCategoryList([]);
      try {
        const res = await fathCategoryApi({});
        if (res?.data?.status === 200) {
          setCategoryList(res?.data?.data?.list || []);
          // setTotal(res?.data?.data?.total)
        } else {
          elseMessage(res);
          setCategoryList([]);
        }
      } catch (err) {
        catchMessage(err);
        setCategoryList([]);
      }
    };
    fathCategory();
  }, []);
  //----------single-details-------------
  const singleDetails = async () => {
    try {
      showLoader();
      const res = await resourceDetailsApi(id);
      if (res?.data?.status === 200) {
        hideLoader();
        const data = res?.data?.data?.resource;
        setInput({
          ...data,
          name: data?.title,
          externalLink: data?.url,
          category: data?.categoryId?._id,
        });
        if (data?.locationType === "country") {
          const country = data?.country || {}; //JSON.parse
          const state = data?.state || {};
          const city = data?.city || {};

          setSelectedCountry({ label: country?.name, value: country?._id });
          setSelectedState({ label: state?.name, value: state?._id });
          setSelectedCity({ label: city?.name, value: city?._id });
        }
        setImage(data?.coverImage);
        //----ti-only-show-image---setApiImage----
        setApiImage(data?.coverImage);
      } else {
        elseMessage(res);
        hideLoader();
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };

  //-----------update-resource-----------
  const updateResource = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const data = new FormData();
        data.append("resourceId", id);
        data.append("image", image);
        data.append("title", input?.name);
        data.append("url", input?.externalLink);
        data.append("categoryId", input?.category);
        data.append("description", input?.description);
        data.append("locationType", input?.locationType);
        // data.append("categoryId", 123)
        if (input?.locationType === "country") {
          data.append(
            "country",
            JSON.stringify({
              _id: selectedCountry?.value,
              name: selectedCountry?.label,
            })
          );
          data.append(
            "state",
            JSON.stringify({
              _id: selectedState?.value,
              name: selectedState?.label,
            })
          );
          data.append(
            "city",
            JSON.stringify({
              _id: selectedCity?.value,
              name: selectedCity?.label,
            })
          );
        }
        const res = await updateResourceApi(data);
        if (res?.data?.status === 200) {
          navigate(-1);
          buttonLoader(false);
        } else {
          elseMessage(res);
          buttonLoader(false);
        }
      } catch (err) {
        catchMessage(err);
        buttonLoader(false);
      }
    }
  };

  //--------------country-listing------------------------
  useEffect(() => {
    const fathCountry = async () => {
      try {
        const res = await countryApi();
        if (res?.data?.status === 200) {
          const data = res?.data?.data?.country_list || [];
          // console.log('country', data)
          const country = data?.map(({ _id, name }) => ({
            label: name,
            value: _id,
          }));
          setCountry(country);
        } else {
          elseMessage(res);
        }
      } catch (err) {
        catchMessage(err);
      }
    };
    fathCountry();
  }, []);
  //--------------state-listing------------------------
  useEffect(() => {
    const fathState = async (countryId = selectedCountry?.value) => {
      if (selectedCountry?.value) {
        try {
          const res = await stateApi({ countryId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.state_list || [];
            // console.log("stateApi", data)
            const state = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setState(state);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value) {
      fathState(selectedCountry?.value);
    }
  }, [selectedCountry?.value]);
  //--------------city-listing------------------------
  useEffect(() => {
    const fathCity = async (
      countryId = selectedCountry?.value,
      stateId = selectedState?.value
    ) => {
      if (selectedCountry?.value && selectedState?.value) {
        try {
          const res = await cityApi({ countryId, stateId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.city_list || [];
            // console.log("cityAPi", data)
            const city = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setCity(city);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value && selectedState?.value) {
      fathCity(selectedCountry?.value, selectedState?.value);
    }
  }, [selectedCountry?.value, selectedState?.value]);
  useEffect(() => {
    singleDetails();
  }, []);
  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">
            <BackIcon />
            Update Resource
          </h4>
        </div>
        <div className="row">
          <div className="col-8 mt-4">
            <ImageUploader
              image={image}
              setImage={setImage}
              height={280}
              apiImage={imageApi}
            />
          </div>
          <div className="col-4">
            <div className="row">
              <div className="col-12 mb-2">
                <label htmlFor="">Location</label>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="locationType"
                  value={input?.locationType || ""}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="country"
                    control={<Radio />}
                    label="Country"
                  />
                  <FormControlLabel
                    value="world"
                    control={<Radio />}
                    label="World wide"
                  />
                </RadioGroup>
              </div>
              <div className="col-12 mb-2">
                <Input
                  type="text"
                  label="Resource Name"
                  className="form-control"
                  name="name"
                  placeholder="Enter resource name"
                  value={input?.name || ""}
                  onChange={handleChange}
                  error={error?.name}
                  maxLength={40}
                />
              </div>
              <div className="col-12 mb-2">
                <Input
                  type="text"
                  label="External Link"
                  className="form-control"
                  name="externalLink"
                  placeholder="Enter external link"
                  value={input?.externalLink || ""}
                  onChange={handleChange}
                  //   error={error?.externalLink}
                  maxLength={150}
                />
                {error.externalLink && (
                  <p
                    className={`invalid-feedback ${
                      (!input.externalLink &&
                        error.externalLink ===
                          "Please enter an external link" &&
                        "d-block") ||
                      (error.externalLink === "URL must start with https://" &&
                        "d-block")
                    }`}
                  >
                    {error.externalLink}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <Select
                  type="text"
                  label="Category"
                  className="form-control"
                  name="category"
                  value={input?.category || ""}
                  onChange={handleChange}
                  error={error?.category}
                >
                  <option value="">category</option>
                  {categoryList.length > 0 &&
                    categoryList.map(({ _id, title }) => {
                      return (
                        <option key={_id} value={_id}>
                          {title}
                        </option>
                      );
                    })}
                </Select>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            {input?.locationType === "country" && (
              <>
                <div className="col-4 mb-2">
                  <ReactSelector
                    label="Country"
                    name="country"
                    placeholder={"search country"}
                    value={selectedCountry || ""}
                    className={
                      error?.country && !selectedCountry?.value
                        ? "form-control"
                        : ""
                    }
                    option={country}
                    onChange={handleCountry}
                    error={error?.country}
                  />
                </div>

                <div className="col-4 mb-2">
                  <ReactSelector
                    label="State"
                    name="state"
                    value={selectedState || ""}
                    className={
                      error?.state && !selectedState?.value
                        ? "form-control"
                        : ""
                    }
                    option={state}
                    onChange={handleState}
                    error={error?.state}
                    placeholder={"Select State"}
                  />
                </div>

                <div className="col-4 mb-2">
                  <ReactSelector
                    label="City"
                    name="city"
                    value={selectedCity || ""}
                    className={
                      error?.city && !selectedCity?.value ? "form-control" : ""
                    }
                    option={city}
                    onChange={(event) => setSelectedCity(event)}
                    error={error?.city}
                    placeholder="select city"
                  />
                </div>
              </>
            )}
          </div>
          <div
            className={
              input?.locationType !== "country"
                ? "d-flex justify-content-end"
                : ""
            }
          >
            <div className="col-4 mb-5">
              <TextArea
                type="text"
                label="Description"
                className="form-control"
                name="description"
                placeholder="Enter description"
                value={input?.description || ""}
                onChange={handleChange}
                error={error?.description}
                // maxLength={250}
              />
            </div>
          </div>
        </div>
        {/* <div className='text-center'> ref*/}
        <button className="btn_size" onClick={updateResource}>
          Update resource
        </button>
        {/* </div> */}
      </div>
    </div>
  );
};

export default EditResource;
